import React from 'react';
import { useFormState } from 'react-hook-form';
import {
  FormInput,
  FormLabel,
  ProductForm,
} from '../required-product-form/requiredProductFormStyles';

const LegacyRequiredProductForm = ({ product, control, register }) => {
  if (
    !product.legacy_required_product_fields ||
    product.legacy_required_product_fields.length <= 0
  ) {
    return null;
  }

  return (
    <div>
      <ProductForm>
        {product.legacy_required_product_fields.map((field) => (
          <div key={`${field.label}`}>
            <FormLabel>{`${field.label}:`}</FormLabel>
            <FormInput
              name={field.name}
              type="text"
              {...register(field.name, {
                required: `${field.label} is required`,
              })}
            />
          </div>
        ))}
      </ProductForm>
    </div>
  );
};

export default LegacyRequiredProductForm;
